"use client";
import { useAutosizeDocument } from "@hudson/ui/lib/use_autosize";

export default function AutosizeDocument({}) {
  useAutosizeDocument();

  return null;
}
